import Vue from 'vue'
import Vuex from 'vuex'
import gamblingContext from './gamblingPage/gamblingContext'
import cashierContext from './Cashier/cashierContext'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    cashierContext,
    gamblingContext
  },
});
